// import { PlanMetrics } from '../../models/plan-metrics.model';
// import { RouteModel } from "../../models/routes.model";
// import AutoAlertRules from "../automations/rules.component";
// import Channels from "../channels/channels-page.component";
// import Changepassword from "../profile/change-password.component";
// import Profile from "../profile/profile.component";
// import Settings from "../settings/settings.component";
// import { withErrorBoundaries } from '../shared/error-handler.component';
// import TemplateComponent from '../templates';
// import ConversationComponent from '../conversations/channel-conversations';
// import { AppRoutes, TeamsRoutes } from './route.path';
// import { AutomationPrimaryDarkIcon, AutomationPrimaryIcon, ChangepasswordPrimaryDarkIcon, ChangepasswordPrimaryIcon, ChannelPlansPrimaryDarkIcon, ChannelPlansPrimaryIcon, ChannelPrimaryDarkIcon, ChannelPrimaryIcon, ContactsPrimaryDarkIcon, ContactsPrimaryIcon, ConversationsPrimaryDarkIcon, ConversationsPrimaryIcon, DashboardPrimaryDarkIcon, DashboardPrimaryIcon, FalkonAiPurpleIcon, OrganizationsPrimaryDarkIcon, OrganizationsPrimaryIcon, PlansPrimaryDarkIcon, PlansPrimaryIcon, SettingsPrimaryDarkIcon, SettingsPrimaryIcon, TemplatesPrimaryDarkIcon, TemplatesPrimaryIcon, UsersPrimaryDarkIcon, UsersPrimaryIcon, } from '../../icon';
// import DashboardViewComponent from '../channel-dashboard/dashboard.component';
// import ChannelInviteUser from '../channel-users/channel-invite-user.component';
// import ChannelUsers from "../channel-users/channel-users.component";
// import AddChannel from '../channels/add-channel.component';
// import AddLiveChatComponent from '../channels/live-chat.component';
// import ProviderViewComponent from '../channels/provider.component';
// import ChannelAllOrganisations from '../channels/system-admin/channels-all-organisations';
// import ChannelAllUsers from '../channels/system-admin/channels-all-users';
// import SystemAdminChannels from '../channels/system-admin/system-admin-all-channels';
// import ChannelsForgetPasswordComponent from '../connect-login/channels-forget-password.component';
// import UserNotFoundComponent from '../connect-login/channels-login-user-not-found.component';
// import ChannelsSetupPasswordComponent from '../connect-login/channels-setup-password.component';
// import ChannelLoginRedirect from '../connect-login/connect-login-redirect.component';
// import ChannelsLoginComponent from '../connect-login/connect-login.component';
// import ChannelsSignUpComponent from '../connect-login/connect-sign-up.component';
// import Contacts from "../contacts/contact.component";
// import LiveChatComponent from '../live-chat/live-chat-popup-component';
// import LiveChatConversationComponent from '../live-chat/live-chat-popup-conversation.component';
// import LiveChatShareToChatLinkComponent from "../live-chat/live-chat-share-to-chat-link-component";
// import BusinessHoursComponent from '../settings/business-hours.component';
// import Signature from '../settings/channel-signature.component';
// import TimeZone from '../settings/channel-time-zone.component';
// import MicrosoftLoginOpenPopup from '../connect-login/channels-teams-microsoft-open-popup';
// import ChannelPlans from '../channel-plans/channel-plans.component';
// import AddWhatsappTemplateSetupComponent from '../templates/whatsapp-add-template-set-up.component';
// import AddWhatsappTemplateEditAndPreviewComponent from '../templates/whatsapp-add-template-edit-preview.component';
// import AddWhatsappTemplateSuccess from '../templates/whatsapp-template-sucess-screen.component';
// import ShopifyAuthentication from '../connect-login/shopify-authentication.component';
// import ShopifyAuthenticationCallBackComponent from '../connect-login/shopify-authentication-callback.component';
// import ChannelChatBotConfigurations from '../channel-chatbot/initialization';
// import WebsiteRefineMessage from '../falkon-website-ai-features/refine-message';
// import { ChannelPlanModel } from '../../models/users.model';
// import FalkonAi from '../falkon-ai';
// import ChannelPlanSelectComponent from '../channel-plans/select-plan.component';

import React from 'react';
import { RouteModel } from '../../models/routes.model';
import { DashboardPrimaryIcon, DashboardPrimaryDarkIcon, UsersPrimaryIcon, UsersPrimaryDarkIcon, ChannelPlansPrimaryIcon, ChannelPlansPrimaryDarkIcon, ConversationsPrimaryIcon, ConversationsPrimaryDarkIcon, ContactsPrimaryIcon, ContactsPrimaryDarkIcon, ChangepasswordPrimaryIcon, ChangepasswordPrimaryDarkIcon, SettingsPrimaryIcon, SettingsPrimaryDarkIcon, AutomationPrimaryIcon, AutomationPrimaryDarkIcon, TemplatesPrimaryIcon, TemplatesPrimaryDarkIcon, ChannelPrimaryIcon, ChannelPrimaryDarkIcon, OrganizationsPrimaryIcon, OrganizationsPrimaryDarkIcon, FalkonAiPurpleIcon } from '../../icon';
import { PlanMetrics } from '../../models/plan-metrics.model';
import { ChannelPlanModel, ChannelPlanStatus } from '../../models/users.model';
import ChannelInviteUser from '../channel-users/channel-invite-user.component';
import { withErrorBoundaries } from '../shared/error-handler.component';
import { AppRoutes, TeamsRoutes } from './route.path';
import store from '../../stores/app-store';


// Lazy Page Imports (split chunks)
const DashboardViewComponent = React.lazy(() => import('../channel-dashboard/dashboard.component'));
const ChannelUsers = React.lazy(() => import('../channel-users/channel-users.component'));
const ChannelPlans = React.lazy(() => import('../channel-plans/channel-plans.component'));
const ConversationComponent = React.lazy(() => import('../conversations/channel-conversations'));
const Contacts = React.lazy(() => import("../contacts/contact.component"));
const Changepassword = React.lazy(() => import("../profile/change-password.component"));
const Settings = React.lazy(() => import("../settings/settings.component"));
const Profile = React.lazy(() => import("../profile/profile.component"));
const AutoAlertRules = React.lazy(() => import("../automations/rules.component"));
const TemplateComponent = React.lazy(() => import('../templates'));
const BusinessHoursComponent = React.lazy(() => import('../settings/business-hours.component'));
const Signature = React.lazy(() => import('../settings/channel-signature.component'));
const TimeZone = React.lazy(() => import('../settings/channel-time-zone.component'));
const Channels = React.lazy(() => import("../channels/channels-page.component"));
const LiveChatComponent = React.lazy(() => import('../live-chat/live-chat-popup-component'));
const LiveChatConversationComponent = React.lazy(() => import('../live-chat/live-chat-popup-conversation.component'));
const LiveChatShareToChatLinkComponent = React.lazy(() => import("../live-chat/live-chat-share-to-chat-link-component"));
const ChannelsLoginComponent = React.lazy(() => import('../connect-login/connect-login.component'));
const ChannelsSignUpComponent = React.lazy(() => import('../connect-login/connect-sign-up.component'));
const ChannelsSetupPasswordComponent = React.lazy(() => import('../connect-login/channels-setup-password.component'));
const ChannelsForgetPasswordComponent = React.lazy(() => import('../connect-login/channels-forget-password.component'));
const ChannelLoginRedirect = React.lazy(() => import('../connect-login/connect-login-redirect.component'));
const AddChannel = React.lazy(() => import('../channels/add-channel.component'));
const AddLiveChatComponent = React.lazy(() => import('../channels/live-chat.component'));
const ProviderViewComponent = React.lazy(() => import('../channels/provider.component'));
const ChannelAllOrganisations = React.lazy(() => import('../channels/system-admin/channels-all-organisations'));
const ChannelAllUsers = React.lazy(() => import('../channels/system-admin/channels-all-users'));
const SystemAdminChannels = React.lazy(() => import('../channels/system-admin/system-admin-all-channels'));
const UserNotFoundComponent = React.lazy(() => import('../connect-login/channels-login-user-not-found.component'));
const MicrosoftLoginOpenPopup = React.lazy(() => import('../connect-login/channels-teams-microsoft-open-popup'));
const AddWhatsappTemplateSetupComponent = React.lazy(() => import('../templates/whatsapp-add-template-set-up.component'));
const AddWhatsappTemplateEditAndPreviewComponent = React.lazy(() => import('../templates/whatsapp-add-template-edit-preview.component'));
const AddWhatsappTemplateSuccess = React.lazy(() => import('../templates/whatsapp-template-sucess-screen.component'));
const ShopifyAuthentication = React.lazy(() => import('../connect-login/shopify-authentication.component'));
const ShopifyAuthenticationCallBackComponent = React.lazy(() => import('../connect-login/shopify-authentication-callback.component'));
// const ChannelChatBotConfigurations = React.lazy(() => import('../channel-chatbot/initialization'));
const WebsiteRefineMessage = React.lazy(() => import('../falkon-website-ai-features/refine-message'));
const FalkonAi = React.lazy(() => import('../falkon-ai'));
const ChannelPlanSelectComponent = React.lazy(() => import('../channel-plans/select-plan.component'));


export const routes: RouteModel[] = [
    {
        id: 1,
        label: "Dashboard",
        path: AppRoutes.CHANNELS_DASHBOARD,
        component: withErrorBoundaries(DashboardViewComponent, "Dashboard"),
        primaryIcon: DashboardPrimaryIcon,
        primaryDarkIcon: DashboardPrimaryDarkIcon,
        roles: [2, 3, 4],
        authenticationRequired: true,
        isSideMenu: true,
    },
    {
        id: 2,
        label: "My Team",
        path: AppRoutes.CHANNELS_MYTEAM,
        component: withErrorBoundaries(ChannelUsers, "My Team"),
        primaryIcon: UsersPrimaryIcon,
        primaryDarkIcon: UsersPrimaryDarkIcon,
        roles: [2, 4],
        authenticationRequired: true,
        isSideMenu: true
    },
    {
        id: 3,
        label: "Plans",
        path: AppRoutes.CHANNELS_PLANS,
        component: withErrorBoundaries(ChannelPlans, "Plans"),
        primaryIcon: ChannelPlansPrimaryIcon,
        primaryDarkIcon: ChannelPlansPrimaryDarkIcon,
        roles: [2, 4],
        authenticationRequired: true,
        isSideMenu: true
    },
    {
        id: 4,
        label: "Conversations",
        path: `${AppRoutes.CONVERSATIONS}/*`,
        component: withErrorBoundaries(ConversationComponent, "Conversations"),
        primaryIcon: ConversationsPrimaryIcon,
        primaryDarkIcon: ConversationsPrimaryDarkIcon,
        roles: [2, 3, 4],
        authenticationRequired: true,
        isSideMenu: true,
        highlightDataKey: "unreadMessageCount",
        enableHighlight: true,
        exact: true,
    },
    {
        id: 5,
        label: "Contacts",
        path: AppRoutes.CONTACTS,
        component: withErrorBoundaries(Contacts, "Contacts"),
        primaryIcon: ContactsPrimaryIcon,
        primaryDarkIcon: ContactsPrimaryDarkIcon,
        roles: [2, 3, 4],
        authenticationRequired: true,
        isSideMenu: true,
        exact: true
    },
    {
        id: 28,
        label: "Change Password",
        path: AppRoutes.CHANGE_PASSWORD,
        component: withErrorBoundaries(Changepassword, "Change Password"),
        primaryIcon: ChangepasswordPrimaryIcon,
        primaryDarkIcon: ChangepasswordPrimaryDarkIcon,
        roles: [1, 2, 3, 4],
        authenticationRequired: true,
        isSideMenu: false,
        isUserMenu: true
    },
    {
        id: 6,
        label: "Settings",
        path: AppRoutes.SETTINGS,
        component: withErrorBoundaries(Settings, "Settings"),
        primaryIcon: SettingsPrimaryIcon,
        primaryDarkIcon: SettingsPrimaryDarkIcon,
        roles: [1, 2, 3, 4],
        authenticationRequired: true,
        isSideMenu: false,
        isUserMenu: true,
        exact: true
    },
    {
        id: 7,
        label: "Profile",
        path: AppRoutes.PROFILE,
        component: withErrorBoundaries(Profile, "Profile"),
        roles: [1, 2, 3, 4],
        authenticationRequired: true,
        isSideMenu: false
    },
    {
        id: 8,
        label: "Automation Rules",
        path: AppRoutes.AUTOMATION_RULES,
        component: withErrorBoundaries(AutoAlertRules, "Automation Rules"),
        roles: [2, 3, 4],
        primaryIcon: AutomationPrimaryIcon,
        primaryDarkIcon: AutomationPrimaryDarkIcon,
        authenticationRequired: true,
        isSideMenu: true,
        PlanFilter: "automation-rules"
    },
    {
        id: 9,
        label: "Templates",
        path: `${AppRoutes.TEMPLATES}/*`,
        component: withErrorBoundaries(TemplateComponent, "Templates"),
        primaryIcon: TemplatesPrimaryIcon,
        primaryDarkIcon: TemplatesPrimaryDarkIcon,
        roles: [2, 3, 4],
        authenticationRequired: true,
        isSideMenu: true,
        PlanFilter: "templates"
    },
    {
        id: 10,
        label: "",
        path: AppRoutes.BUSINESS_HOURS,
        component: withErrorBoundaries(BusinessHoursComponent, "blocked contacts"),
        roles: [2, 3, 4],
        authenticationRequired: true,
        isSideMenu: false,
        exact: true
    },
    {
        id: 11,
        label: "Live Chat Conversation",
        path: AppRoutes.LIVE_CHAT_CONVERSATION,
        component: withErrorBoundaries(LiveChatConversationComponent, "live-chat-conversation"),
        primaryIcon: ContactsPrimaryIcon,
        primaryDarkIcon: ContactsPrimaryDarkIcon,
        // secondaryIcon: ContactsPrimaryIcon,
        roles: [2, 3, 4],
        authenticationRequired: false,
        isSideMenu: false,
        exact: true
    },
    {
        id: 12,
        label: "Channels",
        path: AppRoutes.CHANNELS,
        component: withErrorBoundaries(Channels, "Channels"),
        primaryIcon: ChannelPrimaryIcon,
        primaryDarkIcon: ChannelPrimaryDarkIcon,
        roles: [2, 3, 4],
        authenticationRequired: true,
        isSideMenu: true,
        exact: true
    },
    {
        id: 13,
        label: "Falkon Live Chat",
        path: AppRoutes.LIVE_CHAT,
        component: withErrorBoundaries(LiveChatComponent, "Falkon-live-chat"),
        primaryIcon: ChannelPrimaryIcon,
        primaryDarkIcon: ChannelPrimaryDarkIcon,
        roles: [2, 3, 4],
        authenticationRequired: false,
        isSideMenu: false,
        exact: true
    },
    {
        id: 14,
        label: "Share To Chat Link",
        path: AppRoutes.SHARE_TO_CHAT_LINK,
        component: withErrorBoundaries(LiveChatShareToChatLinkComponent, "Share-to-chat-link"),
        primaryIcon: ChannelPrimaryIcon,
        primaryDarkIcon: ChannelPrimaryDarkIcon,
        roles: [2, 3, 4],
        authenticationRequired: false,
        isSideMenu: false,
        exact: true
    },
    {
        id: 15,
        label: "Channels",
        path: AppRoutes.ADD_CHANNELS,
        component: withErrorBoundaries(ProviderViewComponent, "Channels"),
        primaryIcon: ChannelPrimaryIcon,
        primaryDarkIcon: ChannelPrimaryDarkIcon,
        roles: [2, 3, 4],
        authenticationRequired: true,
        isSideMenu: false,
        exact: true
    },
    {
        id: 16,
        label: "Channels",
        path: AppRoutes.ADD_CHANNELS_LIVE_CHAT,
        component: withErrorBoundaries(AddLiveChatComponent, "Channels"),
        primaryIcon: ChannelPrimaryIcon,
        primaryDarkIcon: ChannelPrimaryDarkIcon,
        roles: [2, 3, 4],
        authenticationRequired: true,
        isSideMenu: false,
        exact: true
    },
    {
        id: 17,
        label: "Channels",
        path: AppRoutes.ADD_CHANNELS_BY_TYPE,
        component: withErrorBoundaries(AddChannel, "Channels"),
        primaryIcon: ChannelPrimaryIcon,
        primaryDarkIcon: ChannelPrimaryDarkIcon,
        roles: [2, 3, 4],
        authenticationRequired: true,
        isSideMenu: false,
        exact: true
    },
    {
        id: 18,
        label: "Login",
        path: AppRoutes.CHANNELS_SIGN_IN,
        component: withErrorBoundaries(ChannelsLoginComponent, "login"),
        roles: [1, 2, 3, 4],
        authenticationRequired: false,
        isSideMenu: false,
    },
    {
        id: 19,
        label: "Signup",
        path: AppRoutes.CHANNELS_SIGN_UP,
        component: withErrorBoundaries(ChannelsSignUpComponent, "Sign Up"),
        roles: [1, 2, 3, 4],
        authenticationRequired: false,
        isSideMenu: false,
    },
    {
        id: 20,
        label: "setpassword",
        path: AppRoutes.CHANNELS_SETPASSWORD,
        component: withErrorBoundaries(ChannelsSetupPasswordComponent, "Set Password"),
        roles: [1, 2, 3, 4],
        authenticationRequired: false,
        isSideMenu: false,
    },
    {
        id: 21,
        label: "Forget Password",
        path: AppRoutes.CHANNELS_FORGET_PASSWORD,
        component: withErrorBoundaries(ChannelsForgetPasswordComponent, "Forget Password"),
        roles: [1, 2, 3, 4],
        authenticationRequired: false,
        isSideMenu: false,
    },
    {
        id: 22,
        label: "Login Redirect",
        path: AppRoutes.CHANNELS_LOGIN_REDIRECT,
        component: withErrorBoundaries(ChannelLoginRedirect, "Login Redirect"),
        roles: [1, 2, 3, 4],
        authenticationRequired: false,
        isSideMenu: false,
    },
    {
        id: 23,
        label: "Invite Team",
        path: AppRoutes.CHANNELS_INVIRE_USERS,
        component: withErrorBoundaries(ChannelInviteUser, "Invite Team"),
        primaryIcon: UsersPrimaryIcon,
        primaryDarkIcon: UsersPrimaryDarkIcon,
        roles: [1, 2, 4],
        authenticationRequired: true,
        isSideMenu: false
    },
    {
        id: 24,
        label: "ChannelAllOrganizations",
        path: AppRoutes.CHANNELS_ORGANISATIONS,
        component: withErrorBoundaries(ChannelAllOrganisations, "ChannelAllOrganizations"),
        primaryIcon: OrganizationsPrimaryIcon,
        primaryDarkIcon: OrganizationsPrimaryDarkIcon,
        authenticationRequired: true,
        roles: [1],
        isSideMenu: true
    },
    {
        id: 25,
        label: "ChannelAllUsers",
        path: AppRoutes.CHANNELS_USERS,
        component: withErrorBoundaries(ChannelAllUsers, "ChannelAllUsers"),
        primaryIcon: UsersPrimaryIcon,
        primaryDarkIcon: UsersPrimaryDarkIcon,
        authenticationRequired: true,
        roles: [1],
        isSideMenu: true,
    },
    {
        id: 26,
        label: "SystemAdminChannels",
        path: AppRoutes.SYS_ADMIN_CHANNELS,
        component: withErrorBoundaries(SystemAdminChannels, "SystemAdminChannels"),
        primaryIcon: ChannelPrimaryIcon,
        primaryDarkIcon: ChannelPrimaryDarkIcon,
        authenticationRequired: true,
        roles: [1],
        isSideMenu: true,
    },
    {
        id: 27,
        label: "UserNotFound",
        path: AppRoutes.CHANNELS_USER_NOT_FOUND,
        component: withErrorBoundaries(UserNotFoundComponent, "UserNotFound"),
        primaryIcon: ChannelPrimaryIcon,
        primaryDarkIcon: ChannelPrimaryDarkIcon,
        authenticationRequired: false,
        roles: [1, 2, 3, 4],
        isSideMenu: false,
    },
    {
        id: 31,
        label: "",
        path: AppRoutes.SIGNATURE,
        component: withErrorBoundaries(Signature, "signature"),
        roles: [2, 3, 4],
        authenticationRequired: true,
        isSideMenu: false,
        exact: true
    },
    {
        id: 32,
        label: "",
        path: AppRoutes.TIMEZONE,
        component: withErrorBoundaries(TimeZone, "time zone"),
        roles: [1, 2, 3, 4],
        authenticationRequired: true,
        isSideMenu: false,
        exact: true
    },
    {
        id: 34,
        label: "Microsoft popup",
        path: TeamsRoutes.TEAMS_POPUP_CONTAINER,
        component: withErrorBoundaries(MicrosoftLoginOpenPopup, "Microsoft-popup"),
        roles: [1, 2, 3, 4],
        authenticationRequired: false,
        isSideMenu: false,
    },
    {
        id: 35,
        label: "AddWhatsappTemplateSetup",
        path: AppRoutes.ADD_WHATSAPP_TEMPLATES_SETUP,
        component: withErrorBoundaries(AddWhatsappTemplateSetupComponent, "AddWhatsappTemplateSetup"),
        roles: [2, 3, 4],
        authenticationRequired: true,
        isSideMenu: false
    },
    {
        id: 35,
        label: "AddWhatsappTemplateEditandPreview",
        path: AppRoutes.ADD_WHATSAPP_TEMPLATES_EDIT_AND_PREVIEW,
        component: withErrorBoundaries(AddWhatsappTemplateEditAndPreviewComponent, "AddWhatsappTemplateEditandPreview"),
        roles: [2, 3, 4],
        authenticationRequired: true,
        isSideMenu: false
    },
    {
        id: 35,
        label: "AddWhatsappTemplateEditSucess",
        path: AppRoutes.ADD_WHATSAPP_TEMPLATES_SUCCESS_SCREEN,
        component: withErrorBoundaries(AddWhatsappTemplateSuccess, "AddWhatsappTemplateEditSucess"),
        roles: [2, 3, 4],
        authenticationRequired: true,
        isSideMenu: false
    },
    {
        id: 36,
        label: "Shopify",
        path: AppRoutes.SHOPIFY,
        component: withErrorBoundaries(ShopifyAuthentication, "ShopifyAuthentication"),
        roles: [2, 3, 4],
        authenticationRequired: false,
        isSideMenu: false
    },
    {
        id: 36,
        label: "Shopify",
        path: AppRoutes.SHOPIFY_CALLBACK,
        component: withErrorBoundaries(ShopifyAuthenticationCallBackComponent, "ShopifyAuthenticationCallBackComponent"),
        roles: [2, 3, 4],
        authenticationRequired: false,
        isSideMenu: false
    },
    {
        id: 37,
        label: "ChatBot",
        path: AppRoutes.FALKON_CHAT_BOT,
        component: withErrorBoundaries(FalkonAi, "ChannelChatBot"),
        primaryIcon: FalkonAiPurpleIcon,
        primaryDarkIcon: FalkonAiPurpleIcon,
        roles: [2, 3, 4],
        authenticationRequired: true,
        isSideMenu: true,
        PlanFilter: "",
    },
    {
        id: 38,
        label: "WebsiteRefineMessageFeature",
        path: AppRoutes.WEBSITE_REFINE_MESSAGE,
        component: withErrorBoundaries(WebsiteRefineMessage, "WebsiteRefineMessage"),
        primaryIcon: FalkonAiPurpleIcon,
        primaryDarkIcon: FalkonAiPurpleIcon,
        roles: [],
        authenticationRequired: false,
        isSideMenu: false
    },
    {
        id: 39,
        label: "Select Plan",
        path: AppRoutes.SELECT_PLAN,
        component: withErrorBoundaries(ChannelPlanSelectComponent, "Select Plan"),
        primaryIcon: FalkonAiPurpleIcon,
        primaryDarkIcon: FalkonAiPurpleIcon,
        roles: [2, 3, 4],
        authenticationRequired: true,
        isSideMenu: false,
    },
];

export const getAuthorisedRoutes = (role: number, planMetrics: PlanMetrics): RouteModel[] => {
    return routes.filter(route => route.authenticationRequired && (!planMetrics || !route.PlanFilter || !!planMetrics[route.PlanFilter || ""]) && route.roles.includes(role))
}

export const getSideMenus = (role: number, planMetrics: PlanMetrics): RouteModel[] => {
    return routes.filter(route => route.isSideMenu && (!planMetrics || !route.PlanFilter || !!planMetrics[route.PlanFilter || ""]) && route.roles.includes(role))
}

export const getUserMenus = (role: number, planMetrics: PlanMetrics): RouteModel[] => {
    return routes.filter(route => route.isUserMenu && (!planMetrics || !route.PlanFilter || !!planMetrics[route.PlanFilter || ""]) && route.roles.includes(role))
}

export const getUnAuthorisedRoutes = (): RouteModel[] => {
    return routes.filter(route => !route.authenticationRequired)
}

export const getChannelSideMenus = (role: number, plan: ChannelPlanModel): RouteModel[] => {
    let Routes = routes;
    const AiFeatures = store.getState().AiFeaturesOrgLevel;
    if (!AiFeatures) {
        Routes = routes.filter(x => x.label !== "ChatBot")
    }
    return Routes.filter(route => route.isSideMenu && route.roles.includes(role) && (!!route.PlanFilter ? (plan.FeatureKeys?.includes(route.PlanFilter) && (plan.Status === ChannelPlanStatus.ACTIVE || plan.Status === ChannelPlanStatus.TRAIL)) : true))
}

export const getChanelAuthorisedRoutes = (role: number): RouteModel[] => {
    return routes.filter(route => route.authenticationRequired && route.roles.includes(role))
}
